import React, { useCallback, useEffect, useState } from "react";
import api from "../lib/api";
import { BarTitle } from "../components/CollapseBar";
import { FileCheck2 } from "lucide-react";
import { toast } from "sonner";

const tl = (n) => (Number(n) || 0).toLocaleString("tr-TR", { maximumFractionDigits: 2 });

export default function Cekler() {
  const [rows, setRows] = useState([]);
  const load = useCallback(() => api.get("/cheques").then((r) => setRows(r.data)), []);
  useEffect(() => { load(); }, [load]);
  const setDurum = async (k, v) => { await api.put(`/cheques/${k.id}`, { data: { cek_durum: v } }); toast.success("ÇEK DURUMU KAYDEDİLDİ"); load(); };
  const tone = (k) => (k.cek_durum === "TAHSİL EDİLDİ" ? "text-slate-500" : k.kalan_gun == null ? "" : k.kalan_gun < 0 ? "text-rose-300 font-bold" : k.kalan_gun <= 3 ? "text-amber-300 font-bold" : "");
  return (
    <div data-testid="cheques-page" className="mw-fade-up space-y-3">
      <BarTitle><h1 className="font-head flex items-center gap-2 text-2xl font-bold text-white"><FileCheck2 className="h-6 w-6 text-amber-400" /> ÇEK VADE TAKİBİ</h1></BarTitle>
      <div className="overflow-auto rounded-xl border border-slate-800 bg-slate-900">
        <table className="w-full text-[12px] text-slate-200">
          <thead><tr className="border-b border-slate-700 text-left text-slate-400">{["VADE", "KALAN GÜN", "ÇEK NO", "BANKA", "KEŞİDECİ", "MÜŞTERİ", "TUTAR", "TAKİP NO", "ALINDIĞI TARİH", "DURUM"].map((h) => <th key={h} className="px-2 py-1.5">{h}</th>)}</tr></thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={10} className="px-2 py-6 text-center text-slate-500">ÇEK YOK</td></tr>}
            {rows.map((k) => (
              <tr key={k.id} data-testid={`cek-${k.id}`} className={`border-b border-slate-800 ${tone(k)}`}>
                <td className="px-2 py-1">{k.cek_vade || "—"}</td><td data-testid={`cek-kalan-${k.id}`} className="px-2 py-1">{k.kalan_gun == null ? "—" : k.kalan_gun < 0 ? `${-k.kalan_gun} GÜN GEÇTİ` : `${k.kalan_gun} GÜN`}</td>
                <td className="px-2 py-1">{k.cek_no}</td><td className="px-2 py-1">{k.cek_banka}</td><td className="px-2 py-1">{k.cek_sahibi}</td><td className="px-2 py-1">{k.cari_ad}</td>
                <td className="px-2 py-1 font-bold">{tl(k.tutar)}</td><td className="px-2 py-1 font-mono">{k.takip_no}</td><td className="px-2 py-1">{k.tarih}</td>
                <td className="px-2 py-1"><select data-testid={`cek-durum-${k.id}`} value={k.cek_durum || ""} onChange={(e) => setDurum(k, e.target.value)} className="h-7 rounded border border-slate-700 bg-slate-800 px-1 text-[11px] text-slate-100">
                  {["", "PORTFÖYDE", "BANKAYA VERİLDİ", "TAHSİL EDİLDİ", "KARŞILIKSIZ", "CİRO EDİLDİ"].map((x) => <option key={x} value={x}>{x || "—"}</option>)}</select></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
